import { makeStyles } from '@material-ui/core/styles'
import checkImage from '../../assets/svg/check.svg'

export const useStyles = makeStyles((theme) => ({
  check: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '2px'
    },
    '& input': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px'
    },

    '& label': {
      position: 'relative',
      padding: '2px 0 2px 28px',
      display: 'inline-block',
      cursor: 'pointer',
      color: theme.app.colors.text.primary,

      '&::before': {
        content: '""',
        border: `1px solid ${theme.app.colors.border.dark}`,
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '18px',
        width: '18px',
        background: '#FFF',
        marginRight: '0.5em',
        transition: 'all 0.2s ease',
        position: 'absolute',
        top: '50%',
        left: '0',
        transform: 'translate(0, -50%)',
        borderRadius: '3px'
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        background: 'no-repeat center center',
        backgroundImage: `url(${checkImage})`,
        top: '50%',
        left: '0.65em',
        transform: 'translate(-50%, -50%)',
        color: '#FFF',
        opacity: '0',
        transition: 'all 0.2s ease',
        width: '18px',
        height: '18px'
      }
    },

    '& input:checked + label::after': {
      opacity: '1'
    },

    '& input:checked + label::before': {
      backgroundColor: theme.app.colors.border.dark
    },

    '& input:disabled + label': {
      opacity: 0.5,
      cursor: 'not-allowed'
    },

    '&.input-check--error label::before': {
      border: `1px solid ${theme.app.indication.danger}`,
      backgroundColor: theme.app.colors.input.backgroundError
    },

    '& .custom-input__error': {
      top: 22,
      position: 'absolute',
      color: theme.app.indication.danger,
      fontSize: theme.app.typography.error.fontSize,
      left: 0,
      textWrapMode: 'nowrap'
    },

    '@media (min-width:961px)': {
      '& .custom-input__input': {
        display: 'flex'
      }
    }
  }
}))
